import { CircularProgress, DialogTitle } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import React from "react";

import Button from "../design/button";

export default function ConfirmDialog({
	open,
	onClose,
	action,
	text,
	title,
	confirmText = "Yes",
	cancelText = "No",
	loading = false,
}: {
	open: boolean;
	onClose: () => void;
	action: () => void;
	text: string;
	title?: string;
	confirmText?: string;
	cancelText?: string;
	loading?: boolean;
}) {
	return (
		<Dialog
			open={open}
			// TransitionComponent={Transition}
			keepMounted
			onClose={() => onClose()}
		>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id='alert-dialog-slide-description'>
					{text}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ padding: "20px 45px" }}>
				<Button onClick={() => onClose()} variant='text' disabled={loading}>
				{cancelText}
				</Button>
				<Button onClick={() => action()} color='primary' variant='contained' disabled={loading}>
				{loading ? <CircularProgress size={24} /> : confirmText}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
